import React from "react";
import "./RadioButton.css";

interface RadioButtonProps {
    isActive?: boolean;
    onClick?: () => void;
    children?: React.ReactNode;
}

export const RadioButton: React.FC<RadioButtonProps> = ({
    isActive = false,
    onClick,
    children,
    ...props
}) => {
    return (
        <div onClick={onClick} className="radio-button" {...props}>
            <div className={`r-toggle-${isActive}`}></div>
            {children}
        </div>
    );
};
